/*
 * @Author: 刘欢
 * @LastEditors: 刘欢
 * @Date: 2024-03-12 20:11:57
 * @LastEditTime: 2024-03-12 20:11:57
 * @Description: 新增或编辑仓库档案
 */

import type { IStoreModel, IStoreHouseStore } from '@monorepo/types/document/store/store.types';
import { tableUpdate } from '@monorepo/utils';

const initState: IStoreHouseStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
  },
  keyword: '',
  active_is: false,
};

const DocumentOrderStore: IStoreModel = {
  namespace: 'documentOrderStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.storehouse_num);
      return { ...state, tableList };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default DocumentOrderStore;
